"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const react_router_dom_1 = require("react-router-dom");
const selectors_1 = require("@/store/ducks/systemComponents/selectors");
const listSystemComponentsUseCase_1 = require("@/useCases/systemComponents/listSystemComponentsUseCase");
const index_view_1 = __importDefault(require("./index.view"));
function AssociateSystemComponentsSection() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const { systemId } = (0, react_router_dom_1.useParams)();
    react_1.default.useEffect(() => {
        (0, listSystemComponentsUseCase_1.listSystemComponentsUseCase)(systemId)(dispatch);
    }, [systemId]);
    const areSystemComponentsLoading = (0, react_redux_1.useSelector)(selectors_1.areSystemComponentsLoadingSelector);
    return (react_1.default.createElement(index_view_1.default, { areAssociatedComponentsLoading: areSystemComponentsLoading }));
}
exports.default = AssociateSystemComponentsSection;
